/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Price_NoteInputs */

const en_cp_price_note = /** @type {(inputs: Cp_Price_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All prices include VAT. Semester = 6 months. Team = 3–5 students. Unit economics are in docs/campus/PRICING_CAMPUS.md.`)
};

const id_cp_price_note = /** @type {(inputs: Cp_Price_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua harga sudah termasuk PPN. Semester = 6 bulan. Tim = 3–5 mahasiswa. Rincian unit economics ada di docs/campus/PRICING_CAMPUS.md.`)
};

/**
* | output |
* | --- |
* | "All prices include VAT. Semester = 6 months. Team = 3–5 students. Unit economics are in docs/campus/PRICING_CAMPUS.md." |
*
* @param {Cp_Price_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_price_note = /** @type {((inputs?: Cp_Price_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Price_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_price_note(inputs)
	return en_cp_price_note(inputs)
});